<ngx-loading-bar [color]="'#32728b'" [includeSpinner]="false"></ngx-loading-bar>
<div class="" [ngClass]="{'wrapper': this.authClass}">
  <app-sidebar *ngIf="this.showSidebar"></app-sidebar>
  <div class="sidebar-backdrop" *ngIf="this.showSidebar" (click)="closeSidebar()" aria-hidden="true"></div>
  <div id="content-page" class="" [ngClass]="{'content-page': this.authClass}">
    <app-navbar *ngIf="this.showNavbar"></app-navbar>
    <app-spinner *ngIf="isLoading"></app-spinner>
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
    <app-footer *ngIf="this.showFooter"></app-footer>
  </div>
</div>